import axios from "axios"
import { BaseUrl, JsonConfig, jwtToken } from "./BaseRepository";
import { ErrorMessage, InfoMessage, SuccessMessage } from "../Utils/Utils";
import fileDownload from "js-file-download";
import ExcelJS from 'exceljs';
import FileSaver from 'file-saver';

export const dwnldBillingAutocrawl = async () => {
    try {
        let url = `${BaseUrl}Billing/autocrawlbilling`;
        const res = await axios.get(url, JsonConfig)
        if (res.status === 200) {
            const sample = JSON.parse(res.data)
            return sample;
        }
        else {
            ErrorMessage("Cannot able to get autocrawl data");
            return null;
        }
    }
    catch {
        ErrorMessage("Cannot able to get autocrawl data");
        return null;
    }
}

export const downloadBillingAutoCrawledFiles = async () => {
    try {
        let url = `${BaseUrl}Billing/DownloadZipFile_billing?filename=AutoCrawling_User`;
        const config = {
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${jwtToken}`,
            },
            responseType: "blob",
        }
        const response = await axios.get(url, config);
        if (response.status === 200) {
            fileDownload(response.data, "TimecardFiles.zip");
        }
        else {
            ErrorMessage("Cannot able to download");
        }
    }
    catch {
        ErrorMessage("Internal error, cannot able to download");
    }
}

export const getBillingMasterfile = async () => {
    try {
        let url = `${BaseUrl}Billing/BillingMasterfileGeneration`;
        const data = {}
        const res = await axios.post(url, data, JsonConfig)
        if (res.data.statusCode === 200) {
            const temp = JSON.parse(res.data.payload);
            if (temp.length > 0) {
                let sampleList = temp;
                let loopedList = [];
                loopedList.length = 0;
                let len = sampleList.length;
                let i;
                loopedList.push(['Client / Dept Name', 'W/E Date', 'Portal Name', 'Hours - RT', 'Hours - OT', 'Hours - DT',
                    'Reg. Bill Rate', 'OT Bill Rate', 'DT Bill Rate', 'Approval Status'])
                for (i = 0; i < len; i++) {
                    loopedList.push([
                        // sampleList[i].VMS,
                        sampleList[i].Client_Name,
                        sampleList[i].Weekend_Date,
                        sampleList[i].Portal_Name,
                        sampleList[i].RT_Hours,
                        sampleList[i].OT_Hours,
                        sampleList[i].DT_Hours,
                        sampleList[i].RT_BillRate,
                        sampleList[i].OT_BillRate,
                        sampleList[i].DT_BillRate,
                        sampleList[i].Approved_Status,
                    ])
                }
                const workbook = new ExcelJS.Workbook();
                const worksheet = workbook.addWorksheet('Sheet1');
                for (i = 0; i < loopedList.length; i++) {
                    worksheet.addRow(loopedList[i]);
                }
                workbook.csv.writeBuffer()
                    .then(buffer => {
                        const blob = new Blob([buffer], { type: 'text/csv;charset=utf-8' });
                        FileSaver.saveAs(blob, 'Mastefile.csv');
                    });

                return "downloaded"
            }
        }
        else if (res.data.statusCode === 500) {
            InfoMessage(res.data.message);
            return null;
        }
        else {
            ErrorMessage("Cannot able to get masterfile data");
            return null;
        }
    }
    catch {
        ErrorMessage("Cannot able to get masterfile data");
        return null;
    }
}
export const getBillingMasterfilePayDateData = async (from, to) => {
    try {
        let url = `${BaseUrl}Billing/GetDumpData?from=${from}&to=${to}`;
        const res = await axios.get(url, JsonConfig)
        if (res.data.statusCode === 200) {
            const sample = JSON.parse(res.data.payload)
            return sample;
        }
        else {
            ErrorMessage("Cannot able to get data");
            return null;
        }
    }
    catch {
        ErrorMessage("Cannot able to get data");
        return null;
    }
}
export const downloadBillingMSXL = async (data) => {
    try {
        if (data.length > 0) {
            let loopedList = [];

            // Headers
            loopedList.push([
                'Client / Dept Name', 'W/E Date', 'Portal Name', 
                'Hours - RT', 'Hours - OT', 'Hours - DT', 
                'Reg. Bill Rate', 'OT Bill Rate', 'DT Bill Rate', 
                'Approval Status'
            ]);

            // Function to sanitize only string values
            const sanitizeCellValue = (value) => {
                if (typeof value === 'string' && /^[=+\-@]/.test(value.trim())) {
                    return "'" + value; // Prefix with a single quote only for strings
                }
                return value;
            };

            // Loop through data and ensure numeric values stay as numbers
            for (let i = 0; i < data.length; i++) {
                loopedList.push([
                    sanitizeCellValue(data[i].Client_Name),
                    sanitizeCellValue(data[i].Weekend_Date),
                    sanitizeCellValue(data[i].Portal_Name),
                    Number(data[i].RT_Hours),  // Ensure numeric format
                    Number(data[i].OT_Hours),  // Ensure numeric format
                    Number(data[i].DT_Hours),  // Ensure numeric format
                    sanitizeCellValue(data[i].RT_BillRate),
                    sanitizeCellValue(data[i].OT_BillRate),
                    sanitizeCellValue(data[i].DT_BillRate),
                    sanitizeCellValue(data[i].Approved_Status),
                ]);
            }

            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Sheet1');

            // Add rows from loopedList
            for (let i = 0; i < loopedList.length; i++) {
                worksheet.addRow(loopedList[i]);
            }

            // Export as CSV
            workbook.csv.writeBuffer()
                .then(buffer => {
                    const blob = new Blob([buffer], { type: 'text/csv;charset=utf-8' });
                    FileSaver.saveAs(blob, 'MastefileGridData.csv');
                });

            return "downloaded";
        } else {
            return null;
        }
    } catch {
        ErrorMessage("Cannot get masterfile data");
        return null;
    }
}
export const getBillingMfData = async () => {
    try {
        let url = `${BaseUrl}Billing/MasterFileinGrid`;
        const res = await axios.get(url, JsonConfig)
        if (res.data.result.statusCode === 200) {
            const sample = JSON.parse(res.data.result.payload)
            return sample;
        }
        else {
            ErrorMessage("Cannot able to get data");
            return null;
        }
    }
    catch {
        ErrorMessage("Cannot able to get data, please try again")
    }
}
export const updateBillingMFRow = async (props) => {
    try {
        let url = `${BaseUrl}Billing/UpdateBillingMasterFile`
        let data = props;
        const response = await axios.put(url, data, JsonConfig)
        return response
    }
    catch (err) {
        ErrorMessage("Cannot able to update");
        return null;
    }
}
export const refreshBillingData = async() => {
    try {
        const data = {};
        let url = `${BaseUrl}Billing/BillingMasterfileGeneration`
        const res = await axios.post(url, data, JsonConfig)
        if (res.data.statusCode === 200) {
            const resp = await getBillingMfData()
            SuccessMessage(res.data.message)
            return resp;
        }
        if (res.data.statusCode === 500) {
            InfoMessage(res.data.message)
            return null;
        }
        else {
            ErrorMessage("Cannot able to get data");
            return null;
        }
    }
    catch (err) {
        ErrorMessage("Cannot able to refresh data, please try again");
        return null;
    }
}
export const getBillingInvoiceUploadFileData = async () => {
    try {
        let url = `${BaseUrl}Billing/InvoiceFileinGrid`;
        const res = await axios.get(url, JsonConfig)
        if (res.data.result.statusCode === 200) {
            const sample = JSON.parse(res.data.result.payload)
            return sample;
        }
        else {
            ErrorMessage("Cannot able to get data");
            return null;
        }
    }
    catch {
        ErrorMessage("Cannot able to get data, please try again")
    }
}
export const downloadBillingInvoiceUploadFile = async (data) => {
    try {
        const temp = data;
        if (temp.length > 0) {
            let sampleList = temp;
            let loopedList = [];
            loopedList.length = 0;
            let len = sampleList.length;
            let i;
            loopedList.push(['LineNum', 'Personnelnumber', 'WeekEnddate', 'Transdate', 'ExpenseType', 'Rate',
                'Hour', 'Notes', 'ClientInvoiceRef', 'Txt','JournalLineType'])
            for (i = 0; i < len; i++) {
                loopedList.push([
                    // sampleList[i].VMS,
                    sampleList[i].LineNum,
                    sampleList[i].Personnelnumber,
                    sampleList[i].WeekEnddate,
                    sampleList[i].Transdate,
                    sampleList[i].ExpenseType,
                    sampleList[i].Rate,
                    sampleList[i].Hour,
                    sampleList[i].Notes,
                    sampleList[i].ClientInvoiceRef,
                    sampleList[i].Txt,
                    sampleList[i].JournalLineType,
                ])
            }
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Sheet1');
            for (i = 0; i < loopedList.length; i++) {
                worksheet.addRow(loopedList[i]);
            }
            workbook.csv.writeBuffer()
                .then(buffer => {
                    const blob = new Blob([buffer], { type: 'text/csv;charset=utf-8' });
                    FileSaver.saveAs(blob, 'InvoiceUploadFile.csv');
                });

            return "downloaded"
        }
        else { return null }
    }
    catch {
        ErrorMessage("Cannot able to get data");
        return null;
    }
}
export const refreshBillingInvoiceUploadFileData = async() => {
    try {
        const data = {};
        let url = `${BaseUrl}Billing/BillingInvoiceUploadFileGeneration`
        const res = await axios.post(url, data, JsonConfig)
        if (res.data.statusCode === 200) {
            const resp = await getBillingInvoiceUploadFileData()
            SuccessMessage(res.data.message)
            return resp;
        }
        if (res.data.statusCode === 500) {
            InfoMessage(res.data.message)
            return null;
        }
        else {
            ErrorMessage("Cannot able to get data");
            return null;
        }
    }
    catch (err) {
        ErrorMessage("Cannot able to refresh data, please try again");
        return null;
    }
}




export const downloadUnmatchedXL = async () => {
    try {
        let url = `${BaseUrl}Billing/download_unmatchedlist`;
        const res = await axios.get(url, JsonConfig);

         console.log("API Response:", res.data);

        if (Array.isArray(res.data) && res.data.length > 0) {
            let loopedList = [['VMS','Client_Name', 'WeekEnddate','Portal_Name','RT_Hours','OT_Hours','DT_Hours','RT_BillRate','OT_BillRate','DT_BillRate','status']];

            res.data.forEach(item => {
                loopedList.push([
                    item.vms || '',
                    item.client_Name || '',     
                    item.weekend_Date || '',
                    item.portal_Name || '',
                    item.rT_Hours || '',
                    item.oT_Hours || '',
                    item.dT_Hours || '',
                    item.rT_BillRate || '',
                    item.oT_BillRate || '',
                    item.dT_BillRate || '',
                    item.approved_Status || '',              

                    // item.personnelNumber || '',
                    // item.fileNumber || '',
                    ''
                ]);
            });

            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Unmatched List');

            loopedList.forEach(row => worksheet.addRow(row));

            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

            FileSaver.saveAs(blob, 'UnmatchedData.xlsx');
            SuccessMessage("Download successful!"); // Added success message
        } 
        else {
            ErrorMessage("No data available to download.");
        }
    } 
    catch (error) {
        console.error("Download error:", error);
        ErrorMessage("Unable to download due to an unexpected error.");
    }
};

export const getFolderUploadedDatebilling = async () => {
    try{
        let url = `${BaseUrl}Home/folderUploadedDate?moduleName=billing`
        const response = await axios.get(url, JsonConfig);
        const JsonResponse = response !== null ? response.data : null;
        if(JsonResponse != null){
            if(JsonResponse.statusCode === 200){
                return JsonResponse;
            } else {
                ErrorMessage(JsonResponse.message)
                return null
            }
        } else {
            ErrorMessage("Unable to resolve request");
            return null;
        }
    } catch (err) {
        ErrorMessage("Unable to resolve request")
        return null
    }
}


